<template>
  <div
      class="ui-select"
      v-bind:class="{
      opened: opened,
      'has-info': hasInfo
    }"
      :disabled="disabled"
      :valid="valid"
      :touched="touched"
      :no-label="hideLabel"
      sklepalnik-ui-element
  >

    <!--    wrapper - this whole element gets moved to the top of the DOM tree when options are opened. It has the same class as the root element so that the CSS rules don't have to be re-written -->
    <div class="ui-select" id="wrapper" ref="wrapper"
         :disabled="disabled"
         :valid="valid"
         :touched="touched"
         :no-label="hideLabel"
         :opened="opened"
         :class="{ opened }"
    >
      <div
          class="ui-select__backdrop"
          @click="toggle($event)"
          ref="backdrop"
      ></div>

      <div class="ui-select__field" ref="field" @click="toggle($event)">
        <input
            ref="input"
            type="text"
            :name="name"
            :value="selectedOptionLabel"
            class="icon-padding"
            disabled
        />

        <span ref="label" class="label" v-bind:class="{ up: opened || value !== undefined }">
        {{ label }}
        <span v-if="required">*</span>
      </span>

        <div class="icon">
          <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M1 1L6 6L11 1"
                stroke="#4C4C4C"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="options" ref="options">
          <div class="options-list" ref="options-list">
            <div
                class="options__option"
                v-for="o of options"
                :key="o.label"
                @click="
              $event.stopPropagation();
              select(o);
            "
                :selected="isSelectedValue(o.value)"
            >
              <input type="radio" :name="o.label"/>
              <div class="option__checkbox-wrapper">
                <div class="option__checkbox">
                  <div
                      class="option__checkbox-checked"
                      v-if="isSelectedValue(o.value)"
                  ></div>
                </div>
              </div>
              <div class="option__text">{{ o.label }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <field-validator
        v-if="showValidator()"
        ref="validator"
        :required="required"
        :validate="validate"
        :fieldname="name"
        :limit="true"
        :value="value"
        :type="String"
        v-on:run-result="
        valid = $event;
        $emit('validated');
      "
    ></field-validator>
  </div>
</template>

<script>
import Vue from "vue";
import FieldValidator from "./FieldValidator.vue";
import {FieldValidatorAcknowledgeFG, FieldValidatorProps} from "./FieldValidatorUtils";

export default {
  name: "ui-select",
  components: {
    "field-validator": FieldValidator,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      validator: (value) => {
        return value.every(
            (v) => v.label !== undefined && v.value !== undefined
        );
      },
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    hideLabel: {
      type: Boolean,
      required: false,
    },
    hasInfo: {
      type: Boolean,
      required: false,
    },
    required: FieldValidatorProps.Required,
    validate: FieldValidatorProps.Validate,
  },
  data: function () {
    return {
      opened: false,
      selectedOptionLabel: "",
      closedTargetWidth: undefined,
      valid: true,
      touched: false,
      fg: undefined,

      retainScroll: undefined,
      preOpenBodyOverflow: undefined
    };
  },
  methods: {
    toggle($event) {
      $event.stopPropagation();
      if (this.disabled) return;

      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    },
    async open() {
      const screenHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;

      const screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

      if (this.isMobile()) await this.forceCloseKeyboard();

      const field = this.$refs.field;
      const optionsList = this.$refs["options-list"];
      const fieldBoudingClientRect = field.getBoundingClientRect();
      const partOfForm = this.$el.closest("form");
      const partOfFormBoundingClientRect = partOfForm.getBoundingClientRect();

      document.body.appendChild(this.$refs.wrapper);
      this.preOpenBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      this.$refs.field.style.position = 'absolute';
      this.$refs.field.style.top = fieldBoudingClientRect.top + 'px';
      this.$refs.field.style.left = fieldBoudingClientRect.left + 'px';
      this.$refs.field.style.width = fieldBoudingClientRect.width + 'px';
      this.$refs.input.style.borderBottomLeftRadius = '0';
      this.$refs.input.style.borderBottomRightRadius = '0';
      this.$refs.options.style.borderRadius = '0 0 23px 23px';
      this.$refs.options.style.transform = 'none';

      field.style.zIndex = 103;
      let optionsHeight = 0;

      for (let i = 0; i < optionsList.children.length; i++) {
        if (i % 2 === 1)
          optionsList.children[i].style.backgroundColor =
              "rgba(242, 242, 242, 0.3)";

        optionsHeight += optionsList.children[i].clientHeight + 0.5;
      }

      let recommendedOptionsHeight = (optionsHeight / optionsList.children.length) * 13;

      if (recommendedOptionsHeight > screenHeight * 0.8) {
        recommendedOptionsHeight = screenHeight * 0.8;
      }

      this.$refs.options.style.maxHeight = recommendedOptionsHeight + 'px';

      const fieldTop = fieldBoudingClientRect.top;

      let fieldTranslateString = "";

      if (this.isMobile() && (screenWidth < 1135) && (window.orientation ? window.orientation !== 90 : true)) {

        // make form non-scrollable
        const parsedMarginTop = parseInt(partOfForm.style.marginTop);

        partOfForm.style.position = 'fixed';
        partOfForm.style.top = partOfFormBoundingClientRect.top + (isNaN(parsedMarginTop) ? 0 : -parsedMarginTop - 20) + 'px';
        partOfForm.style.left = partOfFormBoundingClientRect.left + 'px';
        partOfForm.style.width = partOfFormBoundingClientRect.width + 'px';

        this.retainScroll = partOfFormBoundingClientRect.top + (isNaN(parsedMarginTop) ? 0 : -parsedMarginTop);

        this.selectedOptionLabel = undefined;

        if (optionsHeight > screenHeight * 0.5) {
          optionsHeight = screenHeight * 0.5;
        }

        const optionsCenter =
            fieldTop + (field.clientHeight + optionsHeight) / 2;
        const screenCenter = screenHeight / 2;

        const centerDiff = Math.abs(optionsCenter - screenCenter);
        const translate = centerDiff * (screenCenter > optionsCenter ? 1 : -1);

        fieldTranslateString += `translateY(${translate}px)`;

        const currentCenter = field.getBoundingClientRect().x + field.getBoundingClientRect().width / 2;
        const moveXAxis = (screenWidth / 2) - currentCenter;

        fieldTranslateString += ` translateX(${moveXAxis}px)`;
      } else {
        const bottom = fieldTop + field.clientHeight + optionsHeight;

        if (bottom > screenHeight) {
          optionsHeight -= bottom - screenHeight + 5;
        }
      }

      this.$refs.options.style.height = optionsHeight + "px";
      field.style.transform = fieldTranslateString;
      this.opened = true;
      optionsList.style.overflowY = "scroll";

      setTimeout(() => {
        if (this.isMobile()) {
          let inputComputedStyle = getComputedStyle(this.$refs['input']);
          let inputInnerWidth = this.$refs['input'].clientWidth - parseFloat(inputComputedStyle.paddingLeft) - parseFloat(inputComputedStyle.paddingRight);

          if (this.$refs['label'].getBoundingClientRect().width > inputInnerWidth) {
            this.$refs.label.style.fontSize = inputInnerWidth / (this.$refs.label.innerText.length) * 2 + 'px';
          }
        }

        this.toggleBackdrop(true);
      }, 200);
    },
    close() {
      const screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

      const mobile = this.isMobile() && (screenWidth < 1135) && (window.orientation ? window.orientation !== 90 : true);

      this.$refs.options.style.height = 0;
      this.$refs.options.style.transform = 'translateY(5px)';
      this.$refs.options.style.borderRadius = '23px';
      this.$refs.input.style.borderRadius = '25px';
      document.body.style.overflow = this.preOpenBodyOverflow;

      setTimeout(() => {
        this.$refs.field.style.transform = "none";

        setTimeout(() => {
          this.$el.insertAdjacentElement('afterbegin', this.$refs.wrapper);

          this.$refs.field.style.position = 'relative';
          this.$refs.field.style.top = 'unset';
          this.$refs.field.style.left = 'unset';
          this.$refs.field.style.width = '100%';
          this.$refs.field.style.zIndex = '0';

          this.$refs["options-list"].style.overflow = "hidden";
          this.toggleBackdrop(false);

          if (mobile) {
            // remove non-scroll from form
            const partOfForm = this.$el.closest("form");

            partOfForm.style.position = 'static';
            partOfForm.style.top = '0';
            partOfForm.style.left = '0';
            partOfForm.style.width = '100%';
            window.scrollTo(0, -this.retainScroll);
          }

          this.updateSelectedValueLabel(this.value);
          this.opened = false;
        }, mobile ? 200 : 0);
      }, 200);
    },
    select(option) {
      if (this.disabled) return;

      this.touched = true;
      this.close();
      this.$emit("change", option);
      this.$emit("fg-value-change");
    },
    toggleBackdrop(value) {
      this.$refs.backdrop.style.transform = `scaleY(${Number(value)})`;
      this.$refs.backdrop.style.opacity = Number(value);
    },
    updateSelectedValueLabel(value) {
      let option;

      if (value instanceof Date) {
        option = this.options.find((o) =>
            o.value instanceof Date
                ? o.value.getTime() === value.getTime()
                : false
        );
      } else {
        option = this.options.find((o) => o.value === value);
      }

      if (option) {
        this.selectedOptionLabel = option.label;
      } else {
        this.selectedOptionLabel = undefined;
      }
    },
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    setClosedTargetWidth() {
      this.closedTargetWidth = this.$refs.field.clientWidth;
    },
    isSelectedValue(optionValue) {
      if (this.value instanceof Date && optionValue instanceof Date) {
        return this.value.getTime() === optionValue.getTime();
      } else {
        return this.value === optionValue;
      }
    },
    showValidator() {
      return (this.validate || this.required) && this.fg;
    },
    hasValidator() {
      return this.required || this.validate;
    },
    runValidator() {
      if (this.hasValidator()) {
        return this.$refs.validator.run();
      }
    },
    isValid() {
      return this.valid;
    },
    async forceCloseKeyboard() {
      return new Promise((resolve) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('style', 'position: fixed; visibility: hidden;');

        document.body.appendChild(input);

        setTimeout(() => {
          input.focus();
          setTimeout(() => {
            input.setAttribute('style', 'display: none');
            resolve();
          }, 50)
        })
      }, 50)
    }
  },
  watch: {
    value(newValue) {
      this.updateSelectedValueLabel(newValue);

      Vue.nextTick(() => {
        this.runValidator();
      });
    },
    required() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
    validate() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
  },
  mounted: function () {
    FieldValidatorAcknowledgeFG.bind(this)();

    if (this.required || this.validate) {
      this.valid = false;
    } else {
      this.valid = true;
    }

    document.addEventListener("resize", this.setClosedTargetWidth);
    this.setClosedTargetWidth();
    this.updateSelectedValueLabel(this.value);
  },
  destroyed: function () {
    document.removeEventListener("resize", this.setClosedTargetWidth);
    this.fg.onChildDestroyed(this);
  },
};
</script>


<style>
@media (min-width: 280px) {
  .ui-select {
    margin: 48px 0;

    width: 100%;
    max-width: 343px;
    height: 46px;
  }

  #wrapper {
    height: 46px;
    width: 100%;
  }

  #wrapper[opened="true"] {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    max-width: unset;

    z-index: 102;
    margin: 0;
    border-radius: 0;
  }

  .ui-select[no-label] .label {
    display: none;
  }

  .ui-select .ui-select__backdrop {
    position: fixed;
    top: 0;
    left: 0;

    height: 100vh;
    width: 100vw;
    z-index: 102;

    background-color: rgba(0, 0, 0, 0.5);

    transform-origin: center;
    transform: scaleY(0);
    opacity: 0;
    transition: opacity 0.1s linear;
  }

  .ui-select .ui-select__field {
    position: relative;

    width: 100%;
    height: 46px;

    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  .ui-select:not(#wrapper).opened {
    background-color: #f2f2f2;
    border-radius: 25px;

    transition: all 0.6s ease-in-out;
  }

  .ui-select[disabled] .ui-select__field input {
    background-color: #e5e5e5;
  }

  .ui-select .ui-select__field input {
    width: 100%;
    height: 100%;
    padding: 10px 24px;
    font-size: 15px;

    background-color: #ffffff;

    border: 1px solid #969696;
    border-radius: 25px;

    outline: none;

    transition: all 0.1s ease-in-out;

    color: black;
    opacity: 1;
    pointer-events: none;
  }

  .ui-select.opened .ui-select__field input {
    opacity: 1;
    background-color: white;
  }

  .ui-select[touched]:not([valid]) .ui-select__field input {
    border: 1px solid #ed1c24;
  }

  .ui-select.opened .ui-select__field input {
    border-radius: 25px 25px 0 0;
    border: 1px solid #4c4c4c;
    border-bottom: none;
  }

  .ui-select .ui-select__field .label {
    position: absolute;
    margin: 0;
    height: 25px;
    left: 24px;
    top: 9.5px;

    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    color: #4c4c4c;
    white-space: nowrap;

    transition: transform 0.1s ease-in-out, font-size 0.1s ease-in-out,
    background-color 0.2s ease, padding 0.2s ease;
  }

  .ui-select[disabled] .ui-select__field .label {
    /*background-color: #e5e5e5 !important;*/
  }

  div.ui-select:not(.opened) .ui-select__field .label.up {
    font-size: 12px !important;
    transform: translateY(-35px);
  }

  .ui-select .ui-select__field .icon-padding {
    padding-right: 46px !important;
  }

  .ui-select .ui-select__field .icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    right: 3px;
    top: 3px;
    width: 40px;
    height: 40px;

    border: 3px solid transparent;
    border-radius: 24px;
    cursor: pointer;

    text-align: center;
    line-height: 34px;
    color: #4c4c4c;

    transition: transform 0.3s ease-in-out;
  }

  .ui-select:not([disabled]).opened .icon svg path,
  .ui-select:not([disabled]) .ui-select__field .icon:hover svg path {
    stroke: white;
  }

  .ui-select:not([disabled]) .ui-select__field .icon:hover,
  .ui-select:not([disabled]).opened .ui-select__field .icon {
    color: white !important;
    background: #4c4c4c !important;
    transform: rotateZ(180deg);
  }

  .ui-select .ui-select__field .options {
    height: 0px;
    overflow: hidden;
    max-height: 80vh;
    padding-right: 5px;

    transition: height 0.2s ease-in-out, border-radius 0.1s ease-in-out, transform 0.1s ease-in-out;
    transform: translateY(-2px);
    background-color: white;
  }

  .ui-select .ui-select__field .options .options-list {
    height: 100%;
    padding-right: 5px;
    border-radius: 0 0 23px 23px;

    overflow: hidden;
  }

  .ui-select.opened .ui-select__field .options {
    border: 1px solid #4c4c4c;
    box-shadow: 0px 4px 4px -4px rgba(66, 66, 66, 0.2);
    border-radius: 0 0 23px 23px;
    border-top: none;
  }

  .ui-select.opened .ui-select__field .options-list {
    overflow-y: scroll;
  }

  .ui-select .ui-select__field .options .options__option {
    display: flex;

    padding: 11px 0;
    background-color: white;

    border: none;
    cursor: pointer;
  }

  .ui-select .ui-select__field .options .options__option input {
    display: none;
  }

  .ui-select
  .ui-select__field
  .options
  .options__option
  .option__checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  .ui-select .ui-select__field .options .options__option .option__checkbox {
    position: relative;
    width: 24px;
    height: 24px;
    margin: 0 16px 0 24px;

    border: 1px solid #4c4c4c;
    border-radius: 16px;
  }

  .ui-select
  .ui-select__field
  .options
  .options__option
  .option__checkbox
  .option__checkbox-checked {
    position: absolute;
    left: 3px;
    top: 3px;
    width: 16px;
    height: 16px;

    background: #1ea89c;
    border-radius: 14px;
  }

  .ui-select .ui-select__field .options .options__option .option__text {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    color: #4c4c4c;
  }

  /* INPUT FIELDS WITH (?) INFO */
  .has-info {
    width: 90% !important;
    display: inline-block;
  }
}

@media (min-width: 1135px) {
  .ui-select:not(#wrapper).opened {
    background-color: unset;
    border-radius: 0;
  }

  .ui-select .ui-select__backdrop {
    opacity: 0 !important;
  }

  .ui-select .ui-select__field .label.up {
    transform: translateY(-35px);
    font-size: 12px !important;
  }

  .ui-select .ui-select__field .options {
    /*transition: none;*/
  }
}
</style>
